import Navbar from './Navbar'
import enhance from './Navbar.enhancer'

export default enhance(Navbar)



// WEBPACK FOOTER //
// ./src/containers/Navbar/index.js